import React from 'react';
import Game from '../components/Game';
import LoadingBar from '../components/LoadingBar';
import { Divider, DatePicker } from 'antd';
import moment from 'moment';
import axios from 'axios';

const URL = "https://backendqv2-stage.herokuapp.com/date/"

class GameList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            game_ids: [],
            date: moment().format('YYYYMMDD'),
            loading: 1,
            boxscores: []
        };
    }

    componentDidMount() {
        this.gamesList();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.date !== prevState.date) {
            this.setState({ loading: 1 });
            this.gamesList();
        }
    }

    onChange(date, dateString) {
        const formattedDate = moment(dateString, "YYYY-MM-DD").format('YYYYMMDD');
        this.setState({ date: formattedDate });
    }

    gamesList() {
        const uri = `${URL}${this.state.date}`;
        axios.get(uri)
            .then(res => {
                const games_info = res.data;
                this.setState({
                    game_ids: games_info.game_ids,
                    amount_of_games: games_info.game_ids.length,
                    boxscores: games_info.boxscores,
                    loading: 0,
                })
            })
    }

    disabledDate(current) {
        const earliest = moment('2014-10-03', 'YYYY-MM-DD').endOf('day');
        return earliest > current || current > moment().add(1, "days").endOf('day');
    }

    render() {
        const loading = this.state.loading;
        const boxscores = this.state.boxscores;
        const amount_of_games = this.state.amount_of_games;
        const gamesList = boxscores.map(function (b) {
            return <Game key={b.game_id} {...b} />;
        });

        return (
            <div>
                <DatePicker disabledDate={this.disabledDate} onChange={this.onChange.bind(this)} defaultValue={moment()} />
                <Divider />
                {loading === 1 && <LoadingBar loading={loading} />}
                {loading === 0 && amount_of_games <= 0 && <h1>No games to display</h1>}
                {loading === 0 && gamesList}
            </div>
        )
    }
}

export default GameList;